import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Step3AHoldWrapper } from './Step3AHoldStyled'
import {
  BackArrowWrapper, ColorText,
  Container,
  FormBigTitle,
  FormLabel,
  FormRequired,
  FormWrapper,
  TextInform,
  TextPrimaryInform,
} from '../CommonStyled/CommonStyled'
import IMAGES from '../../images'
import { Button, Col, Form, Input, notification, Row } from 'antd'
import AccountInfo from '../AccountInfo'
import {
  BREAKPOINT,
  ERROR_COLOR,
  ERROR_TITLE,
  PAGES,
  TEMPLATE_CODE,
  TEMPLATE_CODE_RELEASE,
  THEME,
} from '../../constant'
import { useRecoilValue } from 'recoil'
import { breakPointState } from '../../recoil/commonState'
import OtpForm from '../OtpForm'
import ConditionRender from '../ConditionRender'
import StepFinal from '../StepFinal'
import validator from '../../validator'
import accountStore from '../../stores/accountStore'
import { checkAccountState } from '../../recoil/accountStateState'

const Step3AHold = props => {
  const { onClickBack, customerInfo, accountInfo, onCancel } = props
  const breakPoint = useRecoilValue(breakPointState)
  const checkAccount = useRecoilValue(checkAccountState)
  const [form] = Form.useForm()

  const [progressStep, setProgressStep] = useState(1)
  const [stepFinalObj, setStepFinalTexts] = useState({})
  const [payloadData, setPayloadData] = useState(null)
  const [resendOtpData, setResendOtpData] = useState(null)

  const handleClickBack = () => {
    setProgressStep(1)
    onClickBack()
  }
  const handleSubmit = (values) => {

    let payloadSendOtp = {
      businessNumber: values?.legalId,
      targetReceiveOtp: checkAccount[0]?.email,
      templateCode: TEMPLATE_CODE_RELEASE,
    }
    accountStore.sendOtp(payloadSendOtp)
      .then(res => {
        if (res?.statusCode == '200') {
          let payloadToUnHold = {
            legalId: values?.legalId,
            status: 'ON_HOLD',
            checkToken: res.data.code,
          }
          setPayloadData(payloadToUnHold)
          setResendOtpData({
            checkToken: res.data.code,
            templateCode: TEMPLATE_CODE_RELEASE,
          })
          setProgressStep(2)
        }
      })
      .catch(error => {
        if (error?.response?.data?.statusCode == '401') {
          onCancel && onCancel()
        }
      })
  }
  const handleCallbackResend = (res) => {
    let newPayloadData = { ...payloadData, checkToken: res?.data?.checkToken }
    let newResendOtpData = { ...resendOtpData, checkToken: res?.data?.checkToken }
    setPayloadData(newPayloadData)
    setResendOtpData(newResendOtpData)
  }
  const handleSubmitOTP = (otp) => {
    let payloadVerify = {
      moduleCode: 'SPECIAL_ACCOUNT',
      checkToken: payloadData.checkToken,
      otp: otp,
      businessNumber: payloadData.legalId,
    }
    console.log(checkAccount)
    accountStore.verifyOtp(payloadVerify)
      .then(resVerify => {
        if (resVerify?.data?.result === true) {
          accountStore.unHoldAccount({
            legalId: payloadData?.legalId,
            status: 'ON_HOLD',
            id: checkAccount[0].id,
            businessNumber: payloadData.legalId,
          })
            .then(res => {
              if (res?.statusCode == '200') {
                let newStepFinalText = {
                  textLine1A: 'Hủy đăng ký số tài khoản: ',
                  variableLine1: checkAccount[0]?.accountNumber,
                  textLine1B: ' thành công.',
                  textLine2: 'Cảm ơn quý khách đã sử dụng dịch vụ của VPBank.',
                  textLine3: 'Mọi thông tin cần hỗ trợ vui lòng liên hệ đội ngũ CSKH của VPBank.',
                  buttonText: 'Đăng ký tài khoản số đẹp khác',
                  buttonLink: null,
                  resetStep: () => onCancel(),
                }
                setStepFinalTexts(newStepFinalText)
                setProgressStep(3)
              }
            })
        } else {
          notification.error({
            message: <ColorText fontSize={'20px'} color={ERROR_COLOR}>{ERROR_TITLE}</ColorText>,
            description: resVerify?.data?.messageCode,
          })
        }
      })
      .catch(error => {
        if (error?.response?.data?.statusCode == '401') {
          onCancel && onCancel()
        }
      })

  }
  const handleClickDisagree = () => {
    let newStepFinalText = {
      textAlign: 'left',
      textLine1A: 'Cảm ơn Quý doanh nghiệp đã đăng ký tài khoản số đẹp của VPBank.',
      textLine2: 'Nhân viên CSKH SME của VPBank sẽ liên hệ để hỗ trợ Quý khách hoàn tất các thủ tục mở tài khoản trong thời gian sớm nhất.',
      textLine3: <div>Mọi thông tin cần hỗ trợ vui lòng liên hệ với VPBank theo Hotline:
        <a style={{ margin: '0 4px' }} href='tel:150023458'>150023458</a>
        hoặc email
        <a style={{ margin: '0 4px' }} href='mailto:smecare@vpbank.com.vn'>smecare@vpbank.com.vn</a>.</div>,
      textLine4: <strong>Cảm ơn Quý doanh nghiệp</strong>,
      buttonText: null,
      buttonLink: null,
      resetStep: null,
    }
    setStepFinalTexts(newStepFinalText)
    setProgressStep(3)
  }

  useEffect(() => {
    if (!customerInfo) return
    form.setFieldsValue({
      documentType: customerInfo.documentType,
      legalId: customerInfo?.legalId,
    })
  }, [customerInfo])

  return (
    <Step3AHoldWrapper>
      <Container>
        <FormWrapper>
          {
            (progressStep === 1) &&
            <BackArrowWrapper>
              <img src={IMAGES.BACK_ARROW} alt={'back'} onClick={handleClickBack} />
            </BackArrowWrapper>
          }

          <ConditionRender visible={progressStep === 1}>
            <Row justify={'center'}>
              <Col xs={24} sm={24} md={24} lg={22} xl={22} xxl={20}>
                <AccountInfo accountNumber={accountInfo?.accountNumber} fee={accountInfo?.reducedFee} />
                <FormBigTitle
                  margin={'48px 0 40px 0'}
                  textAlign={'center'}>
                  Thông tin Quý khách hàng
                </FormBigTitle>
                <Form
                  form={form}
                  layout={'vertical'}
                  onFinish={handleSubmit}
                >
                  <Row
                    gutter={[
                      { xs: 8, sm: 8, md: 16, lg: 16, xl: 16, xxl: 16 },
                      { xs: 8, sm: 8, md: 16, lg: 16, xl: 16, xxl: 16 },
                    ]}
                    justify={{
                      xs: 'center',
                      sm: 'center',
                      md: 'center',
                      lg: 'center',
                      xl: 'center',
                      xxl: 'center',
                    }}
                    align={'bottom'}
                  >
                    {/*<Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>*/}
                    {/*  <Form.Item*/}

                    {/*    label={<>*/}
                    {/*      <FormLabel>Loại giấy tờ</FormLabel>*/}
                    {/*      <FormRequired> * </FormRequired>*/}
                    {/*    </>}*/}
                    {/*    name={'documentType'}*/}
                    {/*  >*/}
                    {/*    <Select*/}
                    {/*      placeholder={'Chọn'}*/}
                    {/*      style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}>*/}
                    {/*      {*/}
                    {/*        SELECT_DOCUMENT_TYPE_LIST.map((item, index) =>*/}
                    {/*          <Select.Option key={index} value={item.value}>{item.label}</Select.Option>,*/}
                    {/*        )*/}
                    {/*      }*/}
                    {/*    </Select>*/}
                    {/*  </Form.Item>*/}
                    {/*</Col>*/}
                    <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16}>
                      <Form.Item
                        label={<>
                          <FormLabel>Số ĐKKD/QĐTL</FormLabel>
                          <FormRequired> * </FormRequired>
                        </>}
                        rules={[{ validator: validator.validateDocumentNumber }]}
                        name={'legalId'}
                      >
                        <Input
                          disabled
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          autoComplete={'off'} placeholder={'Nhập nội dung'} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} style={{ textAlign: 'justify' }}>
                      <Form.Item>
                        <TextInform>
                          Quý doanh nghiệp có số
                          ĐKKD/QĐTL <TextPrimaryInform>{customerInfo?.legalId}</TextPrimaryInform> đang đăng ký sử dụng
                          Tài khoản số <TextPrimaryInform>{checkAccount[0]?.accountNumber}</TextPrimaryInform>.<br />
                          Nếu Quý doanh nghiệp muốn thay đổi và lựa chọn số mới, nhấn “Đồng ý” và nhập mã OTP đã được
                          gửi đến email đã đăng ký để xác nhận thay đổi.<br />
                          Nhấn “Tiếp tục” để tiếp tục hoàn tất đăng ký.<br />
                          Trường hợp không phải Quý doanh nghiệp đang đăng ký sử dụng số TK này, vui lòng liên hệ với
                          VPBank theo hotline <a href={'tel:1900234568'}>1900234568</a> hoặc email <a
                          href={'mailto:smecare@vpbank.com.vn'}>smecare@vpbank.com.vn</a> để được hỗ trợ".<br />
                          Cảm ơn Quý doanh nghiệp.
                        </TextInform>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}
                      style={{ textAlign: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'center' : 'left' }}
                      order={(breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 2 : 1}
                    >
                      <Button
                        style={{
                          minWidth: 120,
                          background: '#EAEAEA',
                          border: '1px solid #EAEAEA',
                          color: '#818181',
                        }}
                        block={(breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM)}
                        type={'default'}
                        onClick={handleClickDisagree}
                      >
                        Không đồng ý
                      </Button>
                    </Col>
                    <Col
                      xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}
                      style={{ textAlign: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'center' : 'right' }}
                      order={(breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 1 : 2}
                    >
                      <Button
                        style={{ minWidth: 120 }}
                        block={(breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM)}
                        type={'primary'} htmlType={'submit'}
                      >
                        Đồng ý
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </ConditionRender>
          <ConditionRender visible={progressStep === 2}>
            <OtpForm
              payloadResend={resendOtpData}
              description={`VPBank đã gửi mã OTP đến email`}
              receivedOtp={checkAccount[0]?.email}
              expiredCountTime={180}
              resendCountTime={30}
              visible={true}
              callbackOtp={handleSubmitOTP}
              callbackResend={handleCallbackResend}
              onCancel={() => {
                onCancel && onCancel()
              }} />
          </ConditionRender>
          <ConditionRender visible={progressStep === 3}>
            <StepFinal
              textAlign={stepFinalObj?.textAlign}
              textLine1A={stepFinalObj?.textLine1A}
              textLine1B={stepFinalObj?.textLine1B}
              variableLine1={stepFinalObj?.variableLine1}
              textLine2={stepFinalObj?.textLine2}
              textLine3={stepFinalObj?.textLine3}
              textLine4={stepFinalObj?.textLine4}
              buttonText={stepFinalObj?.buttonText}
              buttonLink={stepFinalObj?.buttonLink}
              resetStep={stepFinalObj?.resetStep}
            />
          </ConditionRender>
        </FormWrapper>
      </Container>
    </Step3AHoldWrapper>
  )
}

Step3AHold.propTypes = {
  onClickBack: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  accountInfo: PropTypes.object.isRequired,
}

export default Step3AHold
